import { render, staticRenderFns } from "./ContentLinkBlock.vue?vue&type=template&id=bd1bd9d0"
import script from "./ContentLinkBlock.vue?vue&type=script&lang=js"
export * from "./ContentLinkBlock.vue?vue&type=script&lang=js"
import style0 from "./ContentLinkBlock.vue?vue&type=style&index=0&id=bd1bd9d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports